<svelte:options tag='swc-feefo-rating' immutable={true} />

<script>
  import Star from './Star.svelte';

  let rating = 4.6;

  const hasHalfStar = () => {
    const decimal = rating % 1;
    return decimal > 0.25;
  };

  const getFeefoRating = async () => {
    const response = await fetch(
      "https://api.feefo.com/api/10//reviews/summary/service?merchant_identifier=switchcraft&rating=1%2C2%2C3%2C4%2C5"
    );
    const json = await response.json();
    return json.rating.rating;
  };

  const updateFeefoRatings = async () => {
    const ratingResponse = await getFeefoRating();
    rating = ratingResponse;
  };

  updateFeefoRatings();

</script>

<style>

  .main {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rating {
    color: #111155;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-right: 2px;
  }

  .out-of {
    opacity: 0.5;
    font-weight: 400;
    margin-right: 11px;
  }

  .stars {
    display: flex;
    margin-right: 16px;
  }

  .half-star {
    display: inline-block;
    position: relative;
  }
  .half-star::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 0;
    background: white;
  }

  .feefo-img {
    width: 64px;
  }

</style>

<div class="main">
  <span class="rating">{rating}</span>
  <span class="rating out-of">/ 5</span>
  <div class="stars">
    {#each Array(Math.floor(rating)) as star}
      <swc-star></swc-star>
    {/each}
    {#if hasHalfStar()}
      <div class="half-star">
        <swc-star></swc-star>
      </div>
    {/if}
  </div>
  <img class="feefo-img" src="https://www.switchcraft.co.uk/wp-content/themes/switchcraft/images/feefo_dark.png" alt="Feefo" />
</div>
